//	+-----------------------------------------------+
//	| RC UI controller objects					    |
//	+-----------------------------------------------+

/**
 * @file controllers.js
 * @desc This file optionally contains application-specific controller objects that inherit from cardboard's.
 * @author Geoffrey Pursell
 */


define('controllers',[
	// libraries
	"jquery", "underscore", "backbone", "store", "underscore.string", "bowser",

	// app modules
	"cardboard/mainWorkspaceController", "cardboard/dataBoxController", "cardboard/miscControllers", "cardboard/models", "commonDataSources", "cardboard/baseViews", "cardboard/chartViews", "cardboard/databoxes",
	"cardboard/util"
],
function ($, _, Backbone, Store, _s, Bowser,
		  MainWorkspaceController, DataBoxController, MiscControllers, Models, CommonDataSources, Views, Charts, DataBoxViews,
		  Util) {

	console.log("MODULE: controllers");


	/**
	 * @exports controllers
	 * @desc RC controller objects: Contains controller objects that are used to
	 * implement UI flow, track state, and do business logic. Override any
	 * framework-specified controller business logic here.
	 */
	var Controllers = {};

	Controllers.ThisIsTheApp = true;


	/**
	 * @class
	 * @classdesc Provides a controller object to manage the main workspace
	 * @augments BaseControllers.MainWorkspaceController
	 */
	Controllers.MainWorkspaceController = function () {
		this.initialize.apply(this, arguments);
	};
	Util.inherit(MainWorkspaceController, Controllers.MainWorkspaceController, /** @lends module:mainWorkspaceController.prototype */ {
		
	});


	/**
	 * @class
	 * @classdesc Provides a map controller 
	 */
	Controllers.MapController = function () {
		this.initialize.apply(this, arguments);
	};
	Util.inherit(MiscControllers.MapController, Controllers.MapController, /** @lends module:cardboard/miscControllers.MapController.prototype */ {
		
		// URLs for the map frame to use
		schoolsUrl: "http://w20.education.state.mn.us/arcgis/rest/services/SchoolsAllRC/MapServer/0",
		stateOutlineUrl: "http://w20.education.state.mn.us/arcgis/rest/services/StateOutline2/MapServer",
		geometryUrl: "http://tasks.arcgisonline.com/ArcGIS/rest/services/Geometry/GeometryServer",
		districtsUrl: "http://w20.education.state.mn.us/arcgis/rest/services/Districts5/MapServer/0",
		geocodeUrl: "http://geocode.arcgis.com/arcgis/rest/services/World/GeocodeServer"
		
	});



	/**
	 * @class
	 * @classdesc Provides a controller object to manage a databox
	 * @augments BaseControllers.DataBoxController
	 */
	Controllers.DataBoxController = function () {
		this.initialize.apply(this, arguments);
	};
	Util.inherit(DataBoxController, Controllers.DataBoxController, /** @lends module:cardboard/controllers.DataBoxController.prototype */ {
	});



	/**
	 * @class
	 * @classdesc Provides an object to manage global settings and the settings
	 * dialog
	 * @augments Controllers.BaseController
	 */
	Controllers.Settings = function () {
		this.initialize.apply(this, arguments);
	};

	Util.inherit(MiscControllers.Settings, Controllers.Settings, /** @lends module:cardboard/controllers.Settings.prototype */ {
	});



	/**
	 * @class
	 * @classdesc Provides a controller object to manage the databox adder
	 * @augments BaseControllers.DataBoxAdder
	 */
	Controllers.DataBoxAdder = function () {
		this.initialize.apply(this, arguments);
	};

	Util.inherit(MiscControllers.DataBoxAdder, Controllers.DataBoxAdder, /** @lends module:cardboard/controllers.DataBoxAdder.prototype */ {
	});


	/**
	 * @class
	 * @classdesc Provides a controller object to manage the databox adder
	 * @augments BaseControllers.DataBoxAdder
	 */
	Controllers.DynamicTextController = function () {
		this.initialize.apply(this, arguments);
	};

	Util.inherit(MiscControllers.DynamicTextController, Controllers.DynamicTextController, /** @lends module:cardboard/controllers.DataBoxAdder.prototype */ {
	});

	return Controllers;
});

